"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgIconSettings = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgIconSettings = function SvgIconSettings(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#si_settings__clip0)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.055 11.926l-.17-1.824a4.222 4.222 0 01-.997-.413l-1.41 1.169a6.035 6.035 0 01-1.336-1.335l1.169-1.411a4.224 4.224 0 01-.413-.997l-1.824-.17a6.045 6.045 0 010-1.889l1.824-.17c.095-.353.235-.688.413-.997l-1.169-1.41a6.035 6.035 0 011.335-1.336L3.89 2.31c.313-.18.648-.318.996-.413l.17-1.823a6.045 6.045 0 011.888 0l.171 1.824c.353.095.687.235.997.413l1.41-1.169c.513.372.963.823 1.336 1.335L9.69 3.89c.178.31.317.644.412.996l1.825.171a6.047 6.047 0 010 1.889l-1.825.17a4.21 4.21 0 01-.412.998l1.168 1.41a6.037 6.037 0 01-1.335 1.335L8.113 9.69c-.314.18-.649.318-.997.412l-.171 1.825a6.047 6.047 0 01-1.889 0l-.001-.001zM6 8.25a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5z",
    fill: "currentColor"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "si_settings__clip0"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  }))));
};

exports.SvgIconSettings = SvgIconSettings;